import { useSelector } from 'react-redux'
import { modalSelector, setOpenSupportModal } from '../../../../redux/slices/modal'
import InfoModal from '../InfoModal'

const SupportModal = () => {
  const { openSupportModal } = useSelector(modalSelector)

  return (
    <InfoModal
      open={openSupportModal}
      closeSetter={setOpenSupportModal}
      className="support_modal"
      title="Дякуємо!"
      subtitle="Ваше звернення надіслано до служби підтримки користувачів."
    />
  )
}

export default SupportModal
